import { render, staticRenderFns } from "./FormBasiqueError.vue?vue&type=template&id=0c4163b4&scoped=true"
import script from "./FormBasiqueError.vue?vue&type=script&lang=js"
export * from "./FormBasiqueError.vue?vue&type=script&lang=js"
import style0 from "./FormBasiqueError.vue?vue&type=style&index=0&id=0c4163b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4163b4",
  null
  
)

export default component.exports